import React, { Component } from 'react';
import { connect } from 'dva';
import './index.css';

class Layout extends Component {
  componentWillMount() {
    this.props.dispatch({type:'layout/listStateData'});
    this.props.dispatch({type:'linkage/linkageData'});
  }
  render() {
    return (
      <div>{this.props.children}</div>
    );
  }
}

export default connect()(Layout);


// WEBPACK FOOTER //
// ./src/scripts/common/layout/index.js